export default "__VITE_ASSET__DUvwQV1v__"